import { ImpactStatement } from "./";

export type Charity = {
  ein: string;
  chapter: string;
  createdDate: string;
  deleted: boolean;
  source: {
    processId: string;
    source: string;
    modifiedDate: string;
    ein: string;
    name: string;
    ico: string;
    street: string;
    city: string;
    state: string;
    zip: string;
    group: string;
    subsection: string;
    affiliation: string;
    classification: string;
    ruling: string;
    deductibility: string;
    foundation: string;
    activity: string;
    organization: string;
    status: string;
    taxPeriod: string;
    assetCode: string;
    incomeCode: string;
    filingRequirementCode: string;
    pfFilingRequirementCode: string;
    accountingPeriod: string;
    assetAmount: string;
    incomeAmount: string;
    revenueAmount: string;
    nteeCode: string;
    sortName: string;
    lastSyncDate: string;
  };
  managed: {
    score: number;
    exclude: boolean;
    autoUpdate: boolean;
    description: string;
    displayCountry: string;
    displayName: string;
    displayDBA: string;
    displayAddress: string;
    displayWebsite: string;
    displayBannerUrl: string;
    displayBannerFile: File | null;
    displayLogoUrl: string;
    displayLogoFile: File | null;
    hideTestimonials: boolean;
    contactName: string;
    contactPhone: string;
    contactEmail: string;
    contactAddress: string;
    contactCountry: string;
    distributionEmail: string;
    distributionName: string;
    distributionAttention: string;
    distributionAddress: string;
    distributionCountry: string;
    categories: string[];
    modifiedDate: string;
    impactStatements: ImpactStatement[];
    notes: string;
  };
};

export const DefaultCharity: Charity = {
  ein: "",
  chapter: "",
  createdDate: new Date().toISOString(),
  deleted: true,
  source: {
    processId: "",
    source: "",
    modifiedDate: "",
    ein: "",
    name: "",
    ico: "",
    street: "",
    city: "",
    state: "",
    zip: "",
    group: "",
    subsection: "",
    affiliation: "",
    classification: "",
    ruling: "",
    deductibility: "",
    foundation: "",
    activity: "",
    organization: "",
    status: "",
    taxPeriod: "",
    assetCode: "",
    incomeCode: "",
    filingRequirementCode: "",
    pfFilingRequirementCode: "",
    accountingPeriod: "",
    assetAmount: "",
    incomeAmount: "",
    revenueAmount: "",
    nteeCode: "",
    sortName: "",
    lastSyncDate: "",
  },
  managed: {
    score: 0,
    exclude: true,
    autoUpdate: true,
    description: "",
    displayCountry: "",
    displayName: "",
    displayDBA: "1234",
    displayAddress: "",
    displayWebsite: "",
    displayBannerUrl: "",
    displayBannerFile: null,
    displayLogoUrl: "",
    displayLogoFile: null,
    hideTestimonials: false,
    contactName: "",
    contactPhone: "",
    contactEmail: "",
    contactAddress: "",
    contactCountry: "",
    distributionEmail: "",
    distributionName: "",
    distributionAttention: "",
    distributionAddress: "",
    distributionCountry: "",
    categories: [],
    modifiedDate: "",
    impactStatements: [],
    notes: "",
  },
};
